var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    width: 57,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 26.804c4 2.31 4 8.083 0 10.392L9.646 62.804c-4 2.31-9-.577-9-5.196V6.392c0-4.619 5-7.505 9-5.196z",
    fill: "#fff"
  })));
};
export { SvgPlay as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjY0IiB2aWV3Qm94PSIwIDAgNTcgNjQiIHdpZHRoPSI1NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNTQgMjYuODAzOGM0IDIuMzA5NCA0IDguMDgyOSAwIDEwLjM5MjNsLTQ0LjM1MzgzIDI1LjYwNzdjLTQgMi4zMDk0LTguOTk5OTk4LS41NzczLTguOTk5OTk3LTUuMTk2MWwuMDAwMDAyLTUxLjIxNTRjMC00LjYxODggNS4wMDAwMDUtNy41MDU1NSA5LjAwMDAwNS01LjE5NjE1eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";